import React, { ReactNode } from 'react';
import { Box, MarkdownLite, Stack, Text } from '@origin-digital/ods-core';
import { StaticPerkAccordionType } from '../../typings';

const InternetOfferPerkSummary: ReactNode = <Text weight="medium">Internet offer</Text>;

const InternetOfferPerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <Text>
        <MarkdownLite>
          **Get $30/month off** internet plans for 6 months. For new and moving customers.
          Eligibility criteria and T&Cs apply.
        </MarkdownLite>
      </Text>
    </Box>
    <Box>
      <Text>
        <MarkdownLite>**$10/month** ongoing bundle discount^</MarkdownLite>
      </Text>
    </Box>
  </Stack>
);

export const InternetOfferPerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/v1742795686/icons/icon_internet-add_purple.svg',
  accordionSummary: InternetOfferPerkSummary,
  accordionBody: InternetOfferPerkBody,
  accordionDataId: 'internet-offer-perk',
  expanded: false,
  synced: true,
};

const EmployeeInternetOfferPerkBody: React.ReactNode = (
  <Stack space="medium">
    <Box>
      <Text>
        <MarkdownLite>**$10/month** ongoing bundle discount</MarkdownLite>
      </Text>
    </Box>
  </Stack>
);

export const EmployeeInternetOfferPerk: StaticPerkAccordionType = {
  accordionIcon:
    'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/v1742795686/icons/icon_internet-add_purple.svg',
  accordionSummary: InternetOfferPerkSummary,
  accordionBody: EmployeeInternetOfferPerkBody,
  accordionDataId: 'internet-offer-perk',
  expanded: false,
  synced: true,
};
